import styled from '@emotion/styled';

export default function DartRewardContainer() {
  return (
    <Container>
      <DartButtonContainer />
      <DartButtonContainer />
    </Container>
  );
}

const DartButtonContainer = styled.div`
  width: 100%;
  height: 62px;
  border-radius: 16px;
  background-color: ${(props) => props.theme.backgroundColor.bg_dark_3};
`;

const Container = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
  height: fit-content;
`;
